import React from "react";
import ReactPlayer from "react-player"
import styled from "styled-components";
import useMedia from 'utils/useMedia'

const SimpleVideo = ({ content }) => {
    const videoWidth = useMedia("912px", "63.333vw", "89.063vw", "87.85vw")
    const videoHeight = useMedia("512px", "35.556vw", "50vw", "49.299vw")
    return (
        <VideoContainer>
            <InnerVideoContainer>
                <Video 
                        url={content.video}
                        playing={true}
                        controls={true}
                        muted={true}
                        volume={.5}
                        width={videoWidth}
                        height={videoHeight}
                        light={content.image?.sourceUrl}
                    />
            </InnerVideoContainer>
        </VideoContainer>
    )
} 

const Video = styled(ReactPlayer) `
  .react-player__shadow {
    display: none !important;
  }
`

const VideoContainer = styled.div `
    display: flex;
    align-items: center;
`
const InnerVideoContainer = styled.div `
    margin: auto;
`
export default SimpleVideo;
